import { AlertConsumer, AlertConsumerType, AlertProvider } from "components/AlertContext";
import "components/common/Common.css";
import ContentLoading from "components/common/ContentLoading";
import Disclaimer from "interfaces/Disclaimer";
import QuoteDisclaimer from "interfaces/QuoteDisclaimer";
import QuoteSalesOrder from "interfaces/QuoteSalesOrder";
import * as moment from "moment";
import * as numeral from "numeral";
import * as React from "react";
import MaskedInput from "react-text-mask";

interface Props {
    onSubmit: Function;
    onCancel: Function;
    isNewQuote: boolean;
    isDraft: boolean;
    disclaimers: Disclaimer[];
    selectedDisclaimers: QuoteDisclaimer[];
    data: QuoteSalesOrder;
    isLoading: any;
    isError: any;
}

interface State {
    hasValidationErrors: boolean;
    subTotal: number;
    salesTax: number;
    grandTotal: number;
    grandTotalCost: number;
    data: QuoteSalesOrder;
}

const capitalizeFirstLetter = (str: string | undefined) => {
    if (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return "";
};

export default class SalesOrderStep4 extends React.Component<Props, State> {
    private baseUrl: string;
    private unitPriceTypeNames: string[];

    public constructor(props: Props) {
        super(props);

        this.unitPriceTypeNames = ["", "TBD", "NC", "Not Avail", "No Bid", "Note"];

        this.state = {
            hasValidationErrors: false,
            subTotal: 0,
            salesTax: 0,
            grandTotal: 0,
            grandTotalCost: 0,
            data: this.props.data,
        };

        this.baseUrl = document
            .getElementsByTagName("base")[0]
            .getAttribute("href")!;

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitAsDraft = this.handleSubmitAsDraft.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSubmitAsNewOrder = this.handleSubmitAsNewOrder.bind(this);
    }

    public render() {
        let quoteId = this.props.data.quoteId.toString();
        if (this.props.data.isMaster) {
            quoteId += "M";
        }
        if (this.props.data.revisionDate) {
            quoteId += ", rev " + moment(this.props.data.revisionDate).format("l");
        }
        if (this.props.data.isDraft) {
            quoteId += " (Draft)";
        }

        return (
            <AlertProvider>
                <AlertConsumer>
                    {(alertContext: AlertConsumerType) => {
                        return (
                            <div>
                                <div className="card card--form">
                                    <div className="card-block">
                                        <form name="form" className="form">
                                            <div className="box-wrap">
                                                <h2 className="card__title">Sales Order Details</h2>
                                                <div className="box">
                                                    <div className="row">
                                                        <div className="field-group col-sm-6">
                                                            <span className="field-label">Quote</span>
                                                            <span className="field-item">
                                                                {this.state.data.quoteName}
                                                            </span>
                                                        </div>

                                                        <div className="field-group col-sm-6">
                                                            <span className="field-label">Quote ID</span>
                                                            <span className="field-item">{quoteId}</span>
                                                        </div>

                                                        {this.state.data.customers.map((item, index) => (
                                                            <>
                                                                <div className="field-group col-sm-6">
                                                                    <span className="field-label">Customer</span>
                                                                    <span className="field-item">
                                                                        {item.customerName} ({item.customerApiType === 1 ? "BC" : SITE_NAME})
                                                                    </span>
                                                                </div>
                                                                <div className="field-group col-sm-6">
                                                                    <span className="field-label">Customer ID</span>
                                                                    <span className="field-item">
                                                                        {item.customerId}
                                                                    </span>
                                                                </div>
                                                                <div className="field-group col-sm-6">
                                                                    <span className="field-label">Customer Contact</span>
                                                                    <span className="field-item">
                                                                        {item.customerContactName}
                                                                    </span>
                                                                </div>
                                                                <div className="field-group col-sm-6">
                                                                    <span className="field-label">Phone</span>
                                                                    <span className="field-item">
                                                                        <MaskedInput
                                                                            mask={[
                                                                                "(",
                                                                                /[1-9]/,
                                                                                /\d/,
                                                                                /\d/,
                                                                                ")",
                                                                                " ",
                                                                                /\d/,
                                                                                /\d/,
                                                                                /\d/,
                                                                                "-",
                                                                                /\d/,
                                                                                /\d/,
                                                                                /\d/,
                                                                                /\d/,
                                                                            ]}
                                                                            name="phone"
                                                                            disabled
                                                                            className="form-control"
                                                                            placeholder="(xxx) xxx-xxxx"
                                                                            pattern="\(\d{3}\) \d{3}-\d{4}"
                                                                            style={{
                                                                                border: "none",
                                                                                background: "none",
                                                                                padding: 0,
                                                                            }}
                                                                            value={item.phone}
                                                                        />
                                                                    </span>
                                                                </div>
                                                            </>
                                                        ))}

                                                        <div className="field-group col-sm-12">
                                                            <span className="field-label">Project Name</span>
                                                            <span className="field-item">
                                                                {this.state.data.jobName}
                                                            </span>
                                                        </div>

                                                        <div className="field-group col-sm-6">
                                                            <span className="field-label">Project Address</span>
                                                            <span className="field-item">
                                                                {this.state.data.jobAddress}
                                                            </span>
                                                        </div>

                                                        <div className="field-group col-sm-6">
                                                            <span className="field-label">City</span>
                                                            <span className="field-item">
                                                                {this.state.data.jobCity}
                                                            </span>
                                                        </div>

                                                        <div className="field-group col-sm-6">
                                                            <span className="field-label">State</span>
                                                            <span className="field-item">
                                                                {this.state.data.jobState}
                                                            </span>
                                                        </div>

                                                        <div className="field-group col-sm-6">
                                                            <span className="field-label">Zip</span>
                                                            <span className="field-item">
                                                                {this.state.data.jobZip}
                                                            </span>
                                                        </div>

                                                        <div className="field-group col-sm-6">
                                                            <span className="field-label">Taxable</span>
                                                            <span className="field-item">{this.state.data.isTaxable ? "Yes" : "No"}</span>
                                                        </div>

                                                        {this.state.data.salespersonName !== undefined && (
                                                            <>
                                                                <div className="field-group col-sm-6">
                                                                    <span className="field-label">
                                                                        Salesperson
                                                                    </span>
                                                                    <span className="field-item">
                                                                        {this.state.data.salespersonName}
                                                                    </span>
                                                                </div>
                                                            </>
                                                        )}
                                                        {this.state.data.shippingMethod == "direct" && (
                                                            <>
                                                                <div className="field-group col-sm-6">
                                                                    <span className="field-label">
                                                                        Vendor Name
                                                                    </span>
                                                                    <span className="field-item">
                                                                        {this.state.data.selectedVendorName}
                                                                    </span>
                                                                </div>
                                                                <div className="field-group col-sm-6">
                                                                    <span className="field-label">
                                                                        Vendor Number
                                                                    </span>
                                                                    <span className="field-item">
                                                                        {this.state.data.selectedVendorNo}
                                                                    </span>
                                                                </div>
                                                            </>
                                                        )}
                                                        <div className="field-group col-sm-6">
                                                            <span className="field-label">Shipping Method</span>
                                                            <span className="field-item">
                                                                {capitalizeFirstLetter(this.state.data.shippingMethod)}{" "}
                                                                {this.state.data.shippingMethod == "yard" ? capitalizeFirstLetter(this.state.data.shippingMethodYard) : ""}
                                                            </span>
                                                        </div>
                                                        <div className="field-group col-sm-6">
                                                            <span className="field-label">Project Note</span>
                                                            <span className="field-item">
                                                                {this.state.data.projectNote}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {(this.state.data.shippingMethod == "direct" ||
                                                this.state.data.shippingMethodYard == "delivery") && (
                                                    <div className="box-wrap">
                                                        <h2 className="card__title">Shipping Details</h2>
                                                        <div className="box">
                                                            <div className="row">
                                                                <div className="field-group col-sm-6">
                                                                    <span className="field-label">Address</span>
                                                                    <span className="field-item">
                                                                        {this.state.data.shippingAddress}
                                                                    </span>
                                                                </div>
                                                                <div className="field-group col-sm-6">
                                                                    <span className="field-label">City</span>
                                                                    <span className="field-item">
                                                                        {this.state.data.shippingCity}
                                                                    </span>
                                                                </div>
                                                                <div className="field-group col-sm-6">
                                                                    <span className="field-label">State</span>
                                                                    <span className="field-item">
                                                                        {this.state.data.shippingState}
                                                                    </span>
                                                                </div>

                                                                <div className="field-group col-sm-6">
                                                                    <span className="field-label">ZIP Code</span>
                                                                    <span className="field-item">
                                                                        {this.state.data.shippingZip}
                                                                    </span>
                                                                </div>
                                                                <div className="field-group col-sm-6">
                                                                    <span className="field-label">Delivery Date</span>
                                                                    <span className="field-item">
                                                                        {this.state.data.shippingDate &&
                                                                            moment(this.state.data.shippingDate).format(
                                                                                "LL"
                                                                            )}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            <div className="card card--datatables pb-0 mb-4">
                                                <div className="card-block">
                                                    <h2 className="card__title">Material Details</h2>
                                                    {this.state.data.productGroups
                                                        .reduce((acc: any, current: any) => {
                                                            acc.push({
                                                                ...current,
                                                                products: current.products.reduce(
                                                                    (productAcc: any, productCurrent: any) => {
                                                                        if (productCurrent.checked) {
                                                                            productAcc.push({
                                                                                ...productCurrent,
                                                                            });
                                                                        }
                                                                        return productAcc;
                                                                    },
                                                                    []
                                                                ),
                                                                subTotal: current.products
                                                                    .reduce(
                                                                        (productAcc: any, productCurrent: any) => {
                                                                            if (productCurrent.checked) {
                                                                                productAcc.push({
                                                                                    ...productCurrent,
                                                                                });
                                                                            }
                                                                            return productAcc;
                                                                        },
                                                                        []
                                                                    )
                                                                    .reduce(
                                                                        (productAcc: any, productCurrent: any) =>
                                                                            `${parseFloat(productCurrent.amount) +
                                                                            parseFloat(productAcc)
                                                                            }`,
                                                                        0
                                                                    ),
                                                                subTotalCost: current.products
                                                                    .reduce(
                                                                        (productAcc: any, productCurrent: any) => {
                                                                            if (productCurrent.checked) {
                                                                                productAcc.push({
                                                                                    ...productCurrent,
                                                                                });
                                                                            }
                                                                            return productAcc;
                                                                        },
                                                                        []
                                                                    )
                                                                    .reduce(
                                                                        (productAcc: any, productCurrent: any) =>
                                                                            `${parseFloat(productCurrent.totalCost) +
                                                                            parseFloat(productAcc)
                                                                            }`,
                                                                        0
                                                                    ),
                                                            });
                                                            return acc;
                                                        }, [])
                                                        .map((item: any, groupIndex: any) => (
                                                            <div>
                                                                <h5
                                                                    style={{
                                                                        display: `${item.products.length !== 0
                                                                            ? "inherit"
                                                                            : "none"
                                                                            }`,
                                                                    }}
                                                                >
                                                                    {item.name}
                                                                </h5>
                                                                <div className="table-responsive">
                                                                    {item.products.length !== 0 &&
                                                                        this.state.data.shippingMethod == "direct" ? (
                                                                        <table className="table mb-4">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style={{ width: "5%" }}>
                                                                                        Quantity
                                                                                    </th>
                                                                                    <th style={{ width: "5%" }}>UM</th>
                                                                                    <th style={{ width: "40%" }}>
                                                                                        Item
                                                                                    </th>
                                                                                    <th style={{ width: "5%" }}>Price</th>
                                                                                    <th style={{ width: "5%" }}>Amount</th>
                                                                                    <th style={{ width: "20%" }}>Cost</th>
                                                                                    <th style={{ width: "20%" }}>
                                                                                        Total Cost
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {item.products.map(
                                                                                    (item: any, productIndex: any) => (
                                                                                        <tr>
                                                                                            <td style={{ width: "5%" }}>
                                                                                                {item.quantity}
                                                                                            </td>
                                                                                            <td style={{ width: "5%" }}>
                                                                                                {item.unitMeasurement}
                                                                                            </td>
                                                                                            <td style={{ width: "40%" }}>
                                                                                                {item.productName}
                                                                                            </td>
                                                                                            <td
                                                                                                className="text-right"
                                                                                                style={{ width: "5%" }}
                                                                                            >
                                                                                                {numeral(item.price).format(
                                                                                                    "$0,0.00"
                                                                                                )}
                                                                                            </td>
                                                                                            <td
                                                                                                className="text-right"
                                                                                                style={{ width: "5%" }}
                                                                                            >
                                                                                                {numeral(item.amount).format(
                                                                                                    "$0,0.00"
                                                                                                )}
                                                                                            </td>
                                                                                            <td className="text-right"
                                                                                                style={{ width: "20%" }}>
                                                                                                {numeral(item.cost).format(
                                                                                                    "$0,0.00"
                                                                                                )}
                                                                                            </td>
                                                                                            <td className="text-right"
                                                                                                style={{ width: "20%" }}>
                                                                                                {numeral(item.totalCost).format(
                                                                                                    "$0,0.00"
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                )}
                                                                            </tbody>
                                                                            <tfoot>
                                                                                <tr className="sub-total">
                                                                                    <td colSpan={3}>Subtotal</td>
                                                                                    <td colSpan={2} className="text-right">
                                                                                        {numeral(item.subTotal).format(
                                                                                            "$0,0.00"
                                                                                        )}
                                                                                    </td>
                                                                                    <td colSpan={2} className="text-right">
                                                                                        {numeral(item.subTotalCost).format(
                                                                                            "$0,0.00"
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            </tfoot>
                                                                        </table>
                                                                    ) : item.products.length !== 0 &&
                                                                        this.state.data.shippingMethodYard ==
                                                                        "pickup" ? (
                                                                        <table className="table mb-4">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style={{ width: "10%" }}>
                                                                                        Quantity
                                                                                    </th>
                                                                                    <th style={{ width: "10%" }}>UM</th>
                                                                                    <th style={{ width: "40%" }}>
                                                                                        Item
                                                                                    </th>
                                                                                    <th style={{ width: "20%" }}>Price</th>
                                                                                    <th style={{ width: "20%" }}>Amount</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {item.products.map(
                                                                                    (item: any, productIndex: any) => (
                                                                                        <tr>
                                                                                            <td style={{ width: "10%" }}>
                                                                                                {item.quantity}
                                                                                            </td>
                                                                                            <td style={{ width: "10%" }}>
                                                                                                {item.unitMeasurement}
                                                                                            </td>
                                                                                            <td style={{ width: "40%" }}>
                                                                                                {item.productName}
                                                                                            </td>
                                                                                            <td
                                                                                                className="text-right"
                                                                                                style={{ width: "20%" }}
                                                                                            >
                                                                                                {numeral(item.price).format(
                                                                                                    "$0,0.00"
                                                                                                )}
                                                                                            </td>
                                                                                            <td
                                                                                                className="text-right"
                                                                                                style={{ width: "20%" }}
                                                                                            >
                                                                                                {numeral(item.amount).format(
                                                                                                    "$0,0.00"
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                )}
                                                                            </tbody>
                                                                            <tfoot>
                                                                                <tr className="sub-total">
                                                                                    <td colSpan={3}>Subtotal</td>
                                                                                    <td colSpan={2} className="text-right">
                                                                                        {numeral(item.subTotal).format(
                                                                                            "$0,0.00"
                                                                                        )}
                                                                                    </td>

                                                                                </tr>
                                                                            </tfoot>
                                                                        </table>
                                                                    ) : item.products.length !== 0 &&
                                                                        this.state.data.shippingMethodYard ===
                                                                        "delivery" ? (
                                                                        <table className="table mb-4">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style={{ width: "5%" }}>
                                                                                        Quantity
                                                                                    </th>
                                                                                    <th style={{ width: "5%" }}>UM</th>
                                                                                    <th style={{ width: "40%" }}>
                                                                                        Item
                                                                                    </th>
                                                                                    <th style={{ width: "5%" }}>Price</th>
                                                                                    <th style={{ width: "5%" }}>Amount</th>

                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {item.products.map(
                                                                                    (item: any, productIndex: any) => (
                                                                                        <tr>
                                                                                            <td style={{ width: "5%" }}>
                                                                                                {item.quantity}
                                                                                            </td>
                                                                                            <td style={{ width: "5%" }}>
                                                                                                {item.unitMeasurement}
                                                                                            </td>
                                                                                            <td style={{ width: "40%" }}>
                                                                                                {item.productName}
                                                                                            </td>
                                                                                            <td
                                                                                                className="text-right"
                                                                                                style={{ width: "5%" }}
                                                                                            >
                                                                                                {numeral(item.price).format(
                                                                                                    "$0,0.00"
                                                                                                )}
                                                                                            </td>
                                                                                            <td
                                                                                                className="text-right"
                                                                                                style={{ width: "5%" }}
                                                                                            >
                                                                                                {numeral(item.amount).format(
                                                                                                    "$0,0.00"
                                                                                                )}
                                                                                            </td>

                                                                                        </tr>
                                                                                    )
                                                                                )}
                                                                            </tbody>
                                                                            <tfoot>
                                                                                <tr className="sub-total">
                                                                                    <td colSpan={3}>Subtotal</td>
                                                                                    <td colSpan={2} className="text-right">
                                                                                        {numeral(item.subTotal).format(
                                                                                            "$0,0.00"
                                                                                        )}
                                                                                    </td>

                                                                                </tr>
                                                                            </tfoot>
                                                                        </table>
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                            {this.state.data.isTaxable && this.state.data.salesTaxRate !== undefined /*&& this.state.data.salesTaxRate > 0*/ && (
                                                <div className="grand-total-box mb-5">

                                                    <div className="sales-tax2">
                                                        <span>
                                                            Sales Tax
                                                        </span>
                                                        <span>

                                                            {numeral(this.state.data.salesTaxRate!).format(
                                                                "0.[0000]%"
                                                            )}

                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                            {this.state.data.shippingMethod == "direct" ? (
                                                <div>
                                                    <div className="card card--datatables pb-4 mb-4">
                                                        <div className="card card--datatables pb-0 mb-4">
                                                            {this.state.data.costGroups != undefined &&
                                                                this.state.data.costGroups
                                                                    .reduce((acc: any, current: any) => {
                                                                        acc.push({
                                                                            ...current,
                                                                            products: current.products.reduce(
                                                                                (
                                                                                    productAcc: any,
                                                                                    productCurrent: any
                                                                                ) => {
                                                                                    if (productCurrent.checked) {
                                                                                        productAcc.push({
                                                                                            ...productCurrent,
                                                                                        });
                                                                                    }
                                                                                    return productAcc;
                                                                                },
                                                                                []
                                                                            ),
                                                                        });
                                                                        return acc;
                                                                    }, [])
                                                                    .map((item: any, groupIndex: any) => (
                                                                        <div>


                                                                        </div>
                                                                    ))}
                                                        </div>
                                                    </div>
                                                    <div className="grand-total-box mb-5">
                                                        <div className="grand-total2">
                                                            <span style={{ width: "20%" }}>Grand Total</span>
                                                            <span>
                                                                {numeral(this.state.grandTotal).format("$0,0.00")}
                                                            </span>
                                                            <span>
                                                                {numeral(this.state.grandTotalCost).format(
                                                                    "$0,0.00"
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : this.state.data.shippingMethod == "yard" ||
                                                this.state.data.shippingMethod == undefined ? (
                                                <div className="grand-total-box mb-5">
                                                    <div className="grand-total2">
                                                        <span>Grand Total</span>
                                                        <span>
                                                            {numeral(this.state.grandTotal).format("$0,0.00")}
                                                        </span>
                                                    </div>
                                                </div>
                                            ) : (
                                                ""
                                            )}

                                            <div className="mt-4 button-actions text-center">
                                                {this.state.data.shippingMethod == "direct" ? (
                                                    <button
                                                        className="btn-link"
                                                        onClick={(event) => this.handleSubmit(event, 3)}
                                                        disabled={this.props.isLoading}
                                                    >
                                                        Previous
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="btn-link"
                                                        onClick={(event) => this.handleSubmit(event, 2)}
                                                        disabled={this.props.isLoading}
                                                    >
                                                        Previous
                                                    </button>
                                                )}
                                                {/*TODO*/}
                                                {/*<button*/}
                                                {/*    className="btn btn--large btn--secondary"*/}
                                                {/*    onClick={async (event) => {*/}
                                                {/*        await this.props.onSubmit(*/}
                                                {/*            {*/}
                                                {/*                saveAsDraft: true,*/}
                                                {/*            }*/}
                                                {/*        );*/}

                                                {/*        // this.handleSubmitAsDraft(event);*/}
                                                {/*    }}*/}
                                                {/*    disabled={this.props.isLoading}*/}
                                                {/*>*/}
                                                {/*    Save as Draft*/}
                                                {/*</button>*/}
                                                <div className="business-button-holder">
                                                    {!this.props.isLoading ? (
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={async (event) => {
                                                                if (window.confirm('Send this order to business central?')) {
                                                                    await this.props.onSubmit(
                                                                        {
                                                                            saveAsNewOrder: true,
                                                                        }
                                                                    );
                                                                    this.handleSubmitAsNewOrder(event);
                                                                } else {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            disabled={this.props.isLoading}
                                                        >
                                                            Send to Business Central
                                                        </button>
                                                    ) : (
                                                        <ContentLoading />
                                                    )}

                                                    <span>
                                                        Note: The quote will also be saved as a Sales Order
                                                        once sent to business Central
                                                    </span>
                                                </div>
                                                <button
                                                    className="btn-link"
                                                    onClick={this.handleCancel}
                                                    disabled={this.props.isLoading}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        );
                    }}
                </AlertConsumer>
            </AlertProvider>
        );
    }

    public componentDidMount() {

        let subTotal: number;
        let salesTax: number;
        let grandTotal: number;

        let grandTotalCost: number;

        if (
            this.state.data.shippingMethod === "yard" ||
            this.state.data.shippingMethod === undefined
        ) {
            let categories = this.props.data.productGroups;
            if (categories.length === 0) {
                subTotal = 0;
                salesTax = 0;
                grandTotal = 0;
            } else {
                subTotal = categories.reduce(
                    (total, category) => total + category.subTotal,
                    0
                );
                salesTax =
                    this.props.data.salesTaxRate != null && this.props.data.isTaxable
                        ? subTotal * this.props.data.salesTaxRate!
                        : 0;
                grandTotal = subTotal + salesTax;

            }

            this.setState({
                subTotal: subTotal,
                salesTax: salesTax,
                grandTotal: grandTotal,
            });
        } else {
            let categoriesCost = this.props.data.costGroups;

            if (categoriesCost != undefined) {
                if (categoriesCost.length === 0) {
                    grandTotalCost = 0;
                    subTotal = 0;
                    salesTax = 0;
                    grandTotal = 0;
                } else {
                    grandTotalCost = categoriesCost.reduce(
                        (total, category) => total + category.subTotalCost,
                        0
                    );

                    subTotal = categoriesCost.reduce(
                        (total, category) => total + category.subTotal,
                        0
                    );

                    salesTax =
                        this.props.data.salesTaxRate != null && this.props.data.isTaxable
                            ? subTotal * this.props.data.salesTaxRate!
                            : 0;

                    grandTotal = subTotal + salesTax;

                }
            } else {
                grandTotalCost = 0;
                subTotal = 0;
                salesTax = 0;
                grandTotal = 0;
            }

            this.setState({
                subTotal: subTotal,
                salesTax: salesTax,
                grandTotal: grandTotal,
                grandTotalCost: grandTotalCost,
            }, () => {

            });
        }
    }

    private async handleSubmit(
        event: React.MouseEvent<HTMLButtonElement>,
        nextStepNumber?: number
    ) {
        event.preventDefault();

        if (this.state.hasValidationErrors) {
            this.setState({
                hasValidationErrors: false,
            });
        }

        this.props.onSubmit({
            nextStepNumber: nextStepNumber,
        });
    }

    private async handleSubmitAsDraft(
        event: React.MouseEvent<HTMLAnchorElement> | any
    ) {
        event.preventDefault();

        if (this.state.hasValidationErrors) {
            this.setState({
                hasValidationErrors: false,
            });
        }

        this.props.onSubmit({
            saveAsDraft: true,
        });
    }

    private handleCancel(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        this.props.onCancel();
    }

    private async handleSubmitAsNewOrder(
        event: React.MouseEvent<HTMLAnchorElement | any>
    ) {
        event.preventDefault();
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/quotes/SalesOrderStep4.tsx